import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import css from './index.module.css';
import Table from '../../../components/common/table/table';
import Title from '../../../components/common/title';
import { useService } from '../../../services/services';
import { can, route } from '../../../services/utils';
import { LinkComponent as Link } from '../../../components/form/elements/link';
import {
  LIVESTOCK_FODDER_NEED_CREATE,
  LIVESTOCK_FODDER_NEED_VIEW,
} from '../../../router/routes';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

export default function FodderNeeds() {
  const { t } = useTranslation();
  const { fodderNeedService } = useService();

  const { farmUser } = useSelector((state: RootState) => ({
    farmUser: state.global.farmUser,
  }));

  const transKeyPrefix = 'pages.livestock.fodder_need.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      fodderNeedService.index(farmUser.farm_id, {
        page,
        sort,
        desc,
        ...filter,
      }),
    [fodderNeedService, farmUser.farm_id]
  );

  const canCreateFodderNeed = can(farmUser, { title: 'create fodder_need' });

  return (
    <div className={css['index']}>
      <Title title={tp('title')} />
      <div className={css['body']}>
        {canCreateFodderNeed && (
          <div className={css['toolbar']}>
            <div className={css['left']}>
              <div>
                <Link
                  label={tp('new_calculation')}
                  primary={true}
                  linkTo={route(LIVESTOCK_FODDER_NEED_CREATE, {
                    farmId: farmUser.farm_id,
                  })}
                />
              </div>
            </div>
          </div>
        )}
        <Table<any>
          request={request}
          keyAccessor="id"
          columns={[
            {
              accessor: 'period',
              header: tp('periods'),
              sortable: true,
              className: css['strong'],
            },
            //{ accessor: 'avg_animal_count', header: tp('avg_animal_count') },
            {
              accessor: 'winter_period_in_days',
              header: tp('winter_period_in_days'),
            },
            {
              accessor: 'summer_period_in_days',
              header: tp('summer_period_in_days'),
            },
            { accessor: 'dry_total', header: tp('dry_total_t') },
            {
              accessor: 'costs',
              header: tp('costs'),
              sortable: true,
              className: css['strong'],
            },
          ]}
          viewRoute={route(LIVESTOCK_FODDER_NEED_VIEW, {
            farmId: farmUser.farm_id,
          })}
          viewRecordAbility={{ title: 'view fodder_need' }}
        />
      </div>
    </div>
  );
}
